import './index.css'
export default function ContactUS() {

  return (
    <>
        <div className="contact-us-page">
            <span>---------CONTACT-----------</span>
            <h1>Contact Us </h1>
            <h3>Call Us On : 22279263👨‍💻</h3>
        </div>
    </>
  )
}